import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
// Third party packages
import { MatDialog } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
// Custom packages
import { Router } from "@angular/router";
import { AccessLogsService } from "src/app/modules/access-logs/access-logs.service";
import { AuthService } from "src/app/modules/auth/auth.service";
import { CaretakersService } from "src/app/modules/caretakers/caretakers.service";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { DeadlinesService } from "src/app/modules/deadlines/deadlines.service";
import { DocumentArchiveDocsService } from "src/app/modules/properties/document-archive-docs.service";
import { DocumentArchivesService } from "src/app/modules/properties/document-archives.service";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { SuppliersService } from "src/app/modules/suppliers/suppliers.service";
import { TankService } from "src/app/modules/tank/tank.service";
import { UsersService } from "src/app/modules/users/users.service";
import { UtilsService } from "src/app/modules/utils/utils.service";
import { InfoDialogComponent } from "src/app/shared/components/dialogs/info-dialog/info-dialog.component";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { ThemeService } from "src/app/shared/services/theme.service";
import { isArchiveV3Live } from "src/app/shared/utils/archive-switch.utils";
var HomeComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function HomeComponent(themeService, authService, router, translateService, usersService, companiesService, propertiesService, accessLogsService, helperService, deadlinesService, dialog, documentArchivesService, tankService, caretakersService, configService, suppliersService, utilsService, documentArchiveDocsService) {
        this.themeService = themeService;
        this.authService = authService;
        this.router = router;
        this.translateService = translateService;
        this.usersService = usersService;
        this.companiesService = companiesService;
        this.propertiesService = propertiesService;
        this.accessLogsService = accessLogsService;
        this.helperService = helperService;
        this.deadlinesService = deadlinesService;
        this.dialog = dialog;
        this.documentArchivesService = documentArchivesService;
        this.tankService = tankService;
        this.caretakersService = caretakersService;
        this.configService = configService;
        this.suppliersService = suppliersService;
        this.utilsService = utilsService;
        this.documentArchiveDocsService = documentArchiveDocsService;
        this.subscriptions = [];
        this.pageIsLoaded = false;
        this.today = new Date();
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - turnoverDoughnut chart
        this.doughnutChartLabels = [];
        this.doughnutChartData = [];
        this.doughnutChartType = "doughnut";
        this.doughnutChartLegend = true;
        this.doughnutChartColors = [];
        this.doughnutChartOptions = {
            title: {
                display: false,
                text: "",
                position: "top",
            },
            responsive: true,
            legend: {
                display: true,
                position: "right",
                fullWidth: true,
                reverse: false,
                labels: {
                    fontColor: "#333333",
                    fontSize: 15,
                    fontFamily: "Arial",
                },
            },
            tooltips: {
                callbacks: {
                    label: function (tooltipItem, data) {
                        // get the data label and data value to display
                        var dataLabel = data.labels[tooltipItem.index];
                        // convert the data value to local string so it uses a comma seperated number
                        var value = " (" + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString();
                        // Put suffix on label
                        dataLabel += value + "%)";
                        return dataLabel;
                    },
                },
            },
        };
        this.doughnutChartPlugins = [
            {
                // afterDraw: (chart: Chart | any) => {
                // },
                beforeDraw: function (chart) {
                    // Get ctx from string
                    var ctx = chart.ctx;
                },
            },
        ];
        // END - turnoverDoughnut chart
        // BEGIN - companiesLine chart
        this.lineChartLabels = [];
        this.lineChartData = [];
        this.lineChartType = "line";
        this.lineChartLegend = true;
        this.lineChartColors = [];
        this.lineChartOptions = {
            title: {
                display: false,
                text: "",
                position: "top",
            },
            responsive: true,
            legend: {
                display: true,
                position: "top",
                fullWidth: true,
                reverse: false,
                labels: {
                    fontColor: "#333333",
                    fontSize: 15,
                    fontFamily: "Arial",
                },
            },
            scales: {
                xAxes: [
                    {
                        gridLines: {
                            color: "rgba(0, 0, 0, 0.05)",
                        },
                    },
                ],
                yAxes: [
                    {
                        gridLines: {
                            color: "rgba(0, 0, 0, 0.05)",
                        },
                    },
                ],
            },
        };
        this.lineChartPlugins = [];
        // END - companiesLine chart
        this.loggedUserRoleType = "";
        this.totalDocs = {
            totMandatory: 0,
            totInsert: 0,
            totNotInsert: 0,
            totOptional: 0,
        };
        this.progressBarVal = 0;
        this.progressBarValStyle = { width: "0px" };
        this.subscriptionsRevenue = {
            full: 0,
            fullPerc: 0,
            fullbasic: 0,
            fullbasicPerc: 0,
            free: 0,
            freePerc: 0,
            freebasic: 0,
            freebasicPerc: 0,
            test: 0,
            testPerc: 0,
            contratti: 0,
            contrattiPerc: 0,
            checklist: 0,
            checklistPerc: 0,
            pacchettofisso: 0,
            pacchettofissoPerc: 0,
            nfcAccess: 0,
            nfcAccessPerc: 0,
            qrsicurezza: 0,
            qrsicurezzaPerc: 0,
        };
        this.totalSubscriptionsRevenue = 0;
        this.tankDocumentsCount = 0;
        this.disclaimer = {};
        this.lastInsertedDocs = 0;
        this.isCompaniesException = false;
        this.isSuppliersReports = false;
        this.isNewSuppliersInTank = false;
        this.masterShowPropertiesArea = false;
        this.masterShowSuppliersArea = false;
        this.serverDiskUsed = 0;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    HomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Set page title
        this.themeService.setPageTitle("Home");
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) {
            _this.loggedUser = res;
        }));
        this.subscriptions.push(this.authService.loggedUserRequestedRoleObj$.subscribe(function (res) {
            // Activate loading spinners
            _this.usersCount = undefined;
            _this.companiesCount = undefined;
            _this.accessLogsCount = undefined;
            _this.deadlinesCount = undefined;
            _this.propertiesCount = undefined;
            _this.subscriptionsCount = undefined;
            _this.tanksCount = undefined;
            _this.caretakersCount = undefined;
            _this.temporariesCount = undefined;
            if (res.type) {
                _this.loggedUserRoleType = res.type;
            }
            // Temporary users have no dashboard: the properties list is their
            // landing page. replaceUrl keeps the empty home out of the history.
            if (_this.loggedUserRoleType === "temporary") {
                var lang = _this.translateService.currentLang || _this.translateService.defaultLang;
                _this.router.navigate([lang, "app", "properties", "list"], { replaceUrl: true });
                return;
            }
            if (_this.loggedUserRoleType === "master" ||
                _this.loggedUserRoleType === "collaborator") {
                // Check if correct role is set into req headers
                if (res.company && res.company._id) {
                    _this.companyId = res.company._id;
                    if (_this.configService.companiesException.includes(_this.companyId.toString())) {
                        _this.isCompaniesException = true;
                    }
                    else {
                        _this.isCompaniesException = false;
                    }
                    _this.subscriptions.push(_this.companiesService
                        .get(_this.companyId)
                        .subscribe(function (res) {
                        if (res.status) {
                            if (res.data && res.data.subscription) {
                                if (res.data.subscription.suppliers) {
                                    _this.masterShowSuppliersArea = true;
                                }
                                if (res.data.subscription.documentUpload) {
                                    _this.masterShowPropertiesArea = true;
                                }
                            }
                            _this.buildTabsData();
                        }
                    }));
                    // NEW-M21: with the switch of the 3.0.0 archive on, the totals of the new archive, with the
                    // same four names; the legacy route reads the other archive, frozen at the switch
                    var totalDocs$ = isArchiveV3Live()
                        ? _this.documentArchiveDocsService.companyTotals()
                        : _this.companiesService.getCompanyTotalDocs(_this.companyId);
                    _this.subscriptions.push(totalDocs$
                        .subscribe(function (res2) {
                        if (typeof res2.data !== "undefined" &&
                            typeof res2.data.totMandatory !== "undefined" &&
                            typeof res2.data.totInsert !== "undefined" &&
                            typeof res2.data.totNotInsert !== "undefined" &&
                            typeof res2.data.totOptional !== "undefined") {
                            _this.totalDocs = {
                                totMandatory: res2.data.totMandatory,
                                totInsert: res2.data.totInsert,
                                totNotInsert: res2.data.totNotInsert,
                                totOptional: res2.data.totOptional,
                            };
                            _this.progressBarVal = 0;
                            if (_this.totalDocs.totInsert + _this.totalDocs.totNotInsert >
                                0) {
                                _this.progressBarVal = Math.trunc((_this.totalDocs.totInsert /
                                    (_this.totalDocs.totInsert +
                                        _this.totalDocs.totNotInsert)) *
                                    100);
                            }
                            _this.progressBarValStyle = {
                                width: _this.progressBarVal + "%",
                            };
                            _this.totDocs =
                                _this.totalDocs.totOptional + _this.totalDocs.totInsert;
                            // this.progressBarVal = Math.ceil((res2.items.totMandatory - res2.items.totNotInsert) / res2.items.totMandatory);
                            // this.progressBarValStyle = { 'width': `${this.progressBarVal}%` };
                        }
                        return;
                    }, function (err) {
                        _this.helperService.handleError(err);
                    }));
                    var search = {
                        endDate: moment().startOf("day").toISOString(),
                    };
                    if (isArchiveV3Live()) {
                        // NEW-M15-SW: the number of the card from the deadlines of the new archive, from today;
                        // the legacy route answers 410 once the old archive is switched off
                        _this.subscriptions.push(_this.documentArchiveDocsService
                            .deadlines({ start: 0, limit: 1, sort: "endDate", sortVersus: "asc" })
                            .subscribe(function (res2) {
                            if (res2.data && typeof res2.data.totalCount === "number") {
                                _this.deadlinesCount = res2.data.totalCount;
                            }
                        }, function (err) {
                            _this.deadlinesCount = 0;
                            _this.helperService.handleError(err);
                        }));
                    }
                    else {
                        _this.subscriptions.push(_this.deadlinesService
                            .getDocumentsList(0, 10, "endDate", "asc", search)
                            .subscribe(function (res2) {
                            if (res2.data &&
                                res2.data.items &&
                                Array.isArray(res2.data.items)) {
                                _this.deadlinesCount = res2.data.totalCount;
                            }
                        }));
                    }
                    // this.buildTabsData();
                    // this.dialog.open(ConfirmDialogComponent, {
                    //   data: {
                    //     title: "Chiusura estiva",
                    //     message: `Vi informiamo che i nostri uffici resteranno chiusi dal 01/08 al 30/08. I servizi della piattaforma rimarranno regolarmente attivi per tutto il periodo, tranne l'inserimento dei documenti tramite il serbatoio, che riprenderà il primo venerdì di settembre.\n\nIl team di Archedi Vi ringrazia e Vi augura buone vacanze`,
                    //     btnOkText: this.translateService.instant("common.cta.close"),
                    //     btnCancelText: this.translateService.instant("common.cta.close"),
                    //     messageOnly: true,
                    //   },
                    //   width: '500px',
                    // });
                    if (typeof _this.loggedUser.hideHomePopup === "undefined" ||
                        !_this.loggedUser.hideHomePopup) {
                        var msgDialog = "Gentile utente,<br><br>Da oggi è attiva una nuova interfaccia per la ricerca dei documenti, che interessa la ricerca generale in tutti gli immobili e quella più specifica nel singolo immobile. Più semplice e intuitiva, da oggi ricercare uno specifico documento diventa più facile e veloce; ti invitiamo a prendere dimestichezza con le nuove implementazioni, per qualsiasi dubbio non esitare a contattarci.<br><br>Il Team di Archedi<br><br>";
                        var dialogRef = _this.dialog.open(InfoDialogComponent, {
                            data: {
                                title: "LA NUOVA RICERCA È ONLINE!",
                                message: msgDialog,
                                btnCancelText: _this.translateService.instant("common.cta.close"),
                                showBnt: true,
                                chekboxShowAgain: true,
                            },
                            width: "800px",
                        });
                        dialogRef.afterClosed().subscribe(function (res) {
                            if (res && res.notShowAgain) {
                                _this.subscriptions.push(_this.usersService
                                    .updateFields(_this.loggedUser._id, {
                                    hideHomePopup: true,
                                })
                                    .subscribe(function (res) {
                                    // this.loadPage();
                                    // this.eventDeactivate.emit(true);
                                }, function (err) {
                                    _this.helperService.handleError(err);
                                }));
                            }
                        });
                    }
                }
            }
            if (_this.loggedUserRoleType === "admin" ||
                _this.loggedUserRoleType === "operator") {
                // Get tankDocumentsCount data
                _this.subscriptions.push(_this.authService.tankDocumentsCount$.subscribe(function (res) {
                    _this.tankDocumentsCount = res;
                }));
                _this.subscriptions.push(_this.deadlinesService.getSubscriptionsList().subscribe(function (res2) {
                    if (res2.data &&
                        res2.data.items &&
                        Array.isArray(res2.data.items)) {
                        _this.subscriptionsCount = res2.data.totalCount;
                    }
                }));
                _this.subscriptions.push(_this.propertiesService.getSubscriptionsRevenue().subscribe(function (res) {
                    if (res && res.data.items) {
                        _this.subscriptionsRevenue.full = res.data.items.full;
                        _this.subscriptionsRevenue.free = res.data.items.free;
                        _this.subscriptionsRevenue.fullbasic =
                            res.data.items.fullbasic;
                        _this.subscriptionsRevenue.freebasic =
                            res.data.items.freebasic;
                        // this.subscriptionsRevenue.test = res.data.items.test;
                        // this.subscriptionsRevenue.contratti = res.data.items.contratti;
                        // this.subscriptionsRevenue.checklist = res.data.items.checklist;
                        // this.subscriptionsRevenue.pacchettofisso =
                        //   res.data.items.pacchettofisso;
                        // this.subscriptionsRevenue.nfcAccess = res.data.items.nfcAccess;
                        // this.subscriptionsRevenue.qrsicurezza = res.data.items.qrsicurezza;
                        _this.totalSubscriptionsRevenue =
                            _this.subscriptionsRevenue.full +
                                _this.subscriptionsRevenue.free +
                                _this.subscriptionsRevenue.fullbasic +
                                _this.subscriptionsRevenue.freebasic +
                                _this.subscriptionsRevenue.test +
                                _this.subscriptionsRevenue.contratti +
                                _this.subscriptionsRevenue.checklist +
                                _this.subscriptionsRevenue.pacchettofisso +
                                _this.subscriptionsRevenue.nfcAccess +
                                _this.subscriptionsRevenue.qrsicurezza;
                        _this.subscriptionsRevenue.fullPerc =
                            (_this.subscriptionsRevenue.full /
                                _this.totalSubscriptionsRevenue) *
                                100;
                        _this.subscriptionsRevenue.freePerc =
                            (_this.subscriptionsRevenue.free /
                                _this.totalSubscriptionsRevenue) *
                                100;
                        _this.subscriptionsRevenue.fullbasicPerc =
                            (_this.subscriptionsRevenue.fullbasic /
                                _this.totalSubscriptionsRevenue) *
                                100;
                        _this.subscriptionsRevenue.freebasicPerc =
                            (_this.subscriptionsRevenue.freebasic /
                                _this.totalSubscriptionsRevenue) *
                                100;
                        // this.subscriptionsRevenue.testPerc =
                        //   (this.subscriptionsRevenue.test /
                        //     this.totalSubscriptionsRevenue) *
                        //   100;
                        // this.subscriptionsRevenue.contrattiPerc =
                        //   (this.subscriptionsRevenue.contratti /
                        //     this.totalSubscriptionsRevenue) *
                        //   100;
                        // this.subscriptionsRevenue.checklistPerc =
                        //   (this.subscriptionsRevenue.checklist /
                        //     this.totalSubscriptionsRevenue) *
                        //   100;
                        // this.subscriptionsRevenue.pacchettofissoPerc =
                        //   (this.subscriptionsRevenue.pacchettofisso /
                        //     this.totalSubscriptionsRevenue) *
                        //   100;
                        // this.subscriptionsRevenue.nfcAccessPerc =
                        //   (this.subscriptionsRevenue.nfcAccess /
                        //     this.totalSubscriptionsRevenue) *
                        //   100;
                        // this.subscriptionsRevenue.qrsicurezzaPerc =
                        //   (this.subscriptionsRevenue.qrsicurezza /
                        //     this.totalSubscriptionsRevenue) *
                        //   100;
                        _this.subscriptionsRevenue.fullPerc = Number.parseFloat(_this.subscriptionsRevenue.fullPerc.toFixed(2));
                        _this.subscriptionsRevenue.freePerc = Number.parseFloat(_this.subscriptionsRevenue.freePerc.toFixed(2));
                        _this.subscriptionsRevenue.fullbasicPerc = Number.parseFloat(_this.subscriptionsRevenue.fullbasicPerc.toFixed(2));
                        _this.subscriptionsRevenue.freebasicPerc = Number.parseFloat(_this.subscriptionsRevenue.freebasicPerc.toFixed(2));
                        // this.subscriptionsRevenue.testPerc = Number.parseFloat(
                        //   this.subscriptionsRevenue.testPerc.toFixed(2)
                        // );
                        // this.subscriptionsRevenue.contrattiPerc = Number.parseFloat(
                        //   this.subscriptionsRevenue.contrattiPerc.toFixed(2)
                        // );
                        // this.subscriptionsRevenue.checklistPerc = Number.parseFloat(
                        //   this.subscriptionsRevenue.checklistPerc.toFixed(2)
                        // );
                        // this.subscriptionsRevenue.pacchettofissoPerc =
                        //   Number.parseFloat(
                        //     this.subscriptionsRevenue.pacchettofissoPerc.toFixed(2)
                        //   );
                        // this.subscriptionsRevenue.nfcAccessPerc = Number.parseFloat(
                        //   this.subscriptionsRevenue.nfcAccessPerc.toFixed(2)
                        // );
                        // this.subscriptionsRevenue.qrsicurezzaPerc = Number.parseFloat(
                        //   this.subscriptionsRevenue.qrsicurezzaPerc.toFixed(2)
                        // );
                    }
                    _this.buildTabsData();
                }, function (err) {
                    console.warn(err);
                }));
                // Suppliers reports
                _this.suppliersService
                    .getImportList(0, 2, "date", "desc", "")
                    .subscribe(function (result) {
                    var e_1, _a;
                    if (result.data && Array.isArray(result.data)) {
                        var data = result.data;
                        try {
                            for (var data_1 = tslib_1.__values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
                                var el = data_1_1.value;
                                if (moment(el.date).isValid() &&
                                    moment(el.date).diff(moment(), "days") === 0) {
                                    _this.isSuppliersReports = true;
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    }
                });
                // New Suppliers in Tank
                _this.suppliersService
                    .getNewSuppliersInTank(0, 2, "createdAt", "desc", "")
                    .subscribe(function (result) {
                    if (result.data &&
                        Array.isArray(result.data) &&
                        result.data.length) {
                        _this.isNewSuppliersInTank = true;
                    }
                });
                // Utils
                _this.utilsService.getServerDiskSpace().subscribe(function (res) {
                    if (res.status) {
                        _this.serverDiskUsed = res.data.used;
                    }
                });
            }
        }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) {
            if (res.indexOf("canViewLatestDocsInsList") >= 0) {
                _this.subscriptions.push(_this.documentArchivesService
                    .checkHistoricalDocs()
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.lastInsertedDocs = res.data.totalCount;
                    }
                }, function () {
                    // Only an alert: a refused or failed count shows none
                    _this.lastInsertedDocs = 0;
                }));
            }
            else {
                _this.lastInsertedDocs = 0;
            }
        }));
    };
    /**
     * Build appropriate content for dashboard tabs depending on current logged role type
     *
     * @since 1.0.0
     */
    HomeComponent.prototype.buildTabsData = function () {
        var _this = this;
        if (this.loggedUserRoleType === "shared") {
            var lang = this.translateService.currentLang || this.translateService.defaultLang;
            this.router.navigate([lang, "app", "properties", "my-property"]);
            return;
        }
        if (this.loggedUserRoleType === "temporary") {
            var lang = this.translateService.currentLang || this.translateService.defaultLang;
            this.router.navigate([lang, "app", "properties", "list"]);
            return;
        }
        if (this.loggedUserRoleType === "collaborator") {
            var lang = this.translateService.currentLang || this.translateService.defaultLang;
            if (this.masterShowPropertiesArea) {
                this.router.navigate([lang, "app", "properties", "list"]);
            }
            else {
                // this.router.navigate([lang, "app", "companies", "my-company"]);
                this.router.navigate([lang, "app"]);
            }
            return;
        }
        // Reset chart's data
        this.doughnutChartLabels = [];
        this.doughnutChartColors = [];
        this.doughnutChartData = [];
        this.lineChartLabels = [];
        this.lineChartData = [];
        this.lineChartColors = [];
        if (this.loggedUserRoleType === "admin" ||
            this.loggedUserRoleType === "operator") {
            // Doughnut Chart
            this.doughnutChartLabels.push(this.translateService.instant("home.full"));
            this.doughnutChartLabels.push(this.translateService.instant("home.free"));
            this.doughnutChartLabels.push(this.translateService.instant("home.fullbasic"));
            this.doughnutChartLabels.push(this.translateService.instant("home.freebasic"));
            // this.doughnutChartLabels.push(this.translateService.instant("home.test"));
            // this.doughnutChartLabels.push(
            //   this.translateService.instant("home.contracts")
            // );
            // this.doughnutChartLabels.push(
            //   this.translateService.instant("home.checklist")
            // );
            // this.doughnutChartLabels.push(this.translateService.instant('home.fixedPackage'));
            // this.doughnutChartLabels.push(
            //   this.translateService.instant("home.qrSecurity")
            // );
            // this.doughnutChartLabels.push(
            //   this.translateService.instant("home.nfcAccess")
            // );
            this.doughnutChartColors.push({
                backgroundColor: [
                    "#EF5350",
                    "#EC407A",
                    "#AB47BC",
                    "#7E57C2",
                ],
            });
            var chartValues = [];
            chartValues.push(this.subscriptionsRevenue.fullPerc);
            chartValues.push(this.subscriptionsRevenue.freePerc);
            chartValues.push(this.subscriptionsRevenue.fullbasicPerc);
            chartValues.push(this.subscriptionsRevenue.freebasicPerc);
            // chartValues.push(this.subscriptionsRevenue.testPerc);
            // chartValues.push(this.subscriptionsRevenue.contrattiPerc);
            // chartValues.push(this.subscriptionsRevenue.checklistPerc);
            // chartValues.push(this.subscriptionsRevenue.pacchettofissoPerc);
            // chartValues.push(this.subscriptionsRevenue.nfcAccessPerc);
            // chartValues.push(this.subscriptionsRevenue.qrsicurezzaPerc);
            this.doughnutChartData.push(chartValues);
            // Line chart
            this.lineChartLabels.push(moment().subtract(11, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(10, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(9, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(8, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(7, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(6, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(5, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(4, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(3, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(2, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(1, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().format("MMM YYYY"));
            this.lineChartData.push({
                label: this.translateService.instant("home.full"),
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            });
            this.lineChartData.push({
                label: this.translateService.instant("home.free"),
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            });
            this.lineChartData.push({
                label: this.translateService.instant("home.fullbasic"),
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            });
            this.lineChartData.push({
                label: this.translateService.instant("home.freebasic"),
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            });
            // this.lineChartData.push({
            //   label: this.translateService.instant("home.test"),
            //   data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            // });
            // this.lineChartData.push({
            //   label: this.translateService.instant("home.contracts"),
            //   data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            // });
            // this.lineChartData.push({
            //   label: this.translateService.instant("home.checklist"),
            //   data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            // });
            // this.lineChartData.push({
            //   label: this.translateService.instant('home.fixedPackage'),
            //   data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            // });
            // this.lineChartData.push({
            //   label: this.translateService.instant('home.qrFire'),
            //   data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            // });
            // this.lineChartData.push({
            //   label: this.translateService.instant("home.qrSecurity"),
            //   data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            // });
            this.lineChartColors.push({
                backgroundColor: "rgba(255, 255, 255, 0)",
                borderColor: "#EF5350",
            });
            this.lineChartColors.push({
                backgroundColor: "rgba(255, 255, 255, 0)",
                borderColor: "#EC407A",
            });
            this.lineChartColors.push({
                backgroundColor: "rgba(255, 255, 255, 0)",
                borderColor: "#AB47BC",
            });
            this.lineChartColors.push({
                backgroundColor: "rgba(255, 255, 255, 0)",
                borderColor: "#7E57C2",
            });
            // this.lineChartColors.push({
            //   backgroundColor: "rgba(255, 255, 255, 0)",
            //   borderColor: "#5C6BC0",
            // });
            // this.lineChartColors.push({
            //   backgroundColor: "rgba(255, 255, 255, 0)",
            //   borderColor: "#42A5F5",
            // });
            // this.lineChartColors.push({
            //   backgroundColor: "rgba(255, 255, 255, 0)",
            //   borderColor: "#29B6F6",
            // });
            // this.lineChartColors.push({
            //   backgroundColor: "rgba(255, 255, 255, 0)",
            //   borderColor: "#26C6DA",
            // });
            this.subscriptions.push(this.usersService
                .getList(0, 10, "createdAt", "desc", { email: "" })
                .subscribe(function (res) {
                if (res) {
                    _this.usersCount = res.data.totalCount;
                }
            }, function (err) {
                console.warn(err);
            }));
            this.subscriptions.push(this.companiesService
                .getList(0, 10, "createdAt", "desc", { email: "" })
                .subscribe(function (res) {
                if (res) {
                    _this.companiesCount = res.data.totalCount;
                }
            }, function (err) {
                console.warn(err);
            }));
            this.subscriptions.push(this.propertiesService
                .getList(0, 10, "createdAt", "desc", { name: "" })
                .subscribe(function (res) {
                if (res) {
                    _this.propertiesCount = res.data.totalCount;
                }
            }, function (err) {
                console.warn(err);
            }));
        }
        if (this.loggedUserRoleType === "master" ||
            this.loggedUserRoleType === "collaborator") {
            this.doughnutChartLabels.push(this.translateService.instant("home.missingRequired"));
            this.doughnutChartLabels.push(this.translateService.instant("home.mandatoryInserted"));
            this.doughnutChartLabels.push(this.translateService.instant("home.generics"));
            this.doughnutChartColors.push({
                backgroundColor: ["#EF5350", "#7E57C2", "#26C6DA"],
            });
            var chartValues = [30, 50, 20];
            this.doughnutChartData.push(chartValues);
            // Line chart
            this.lineChartLabels.push(moment().subtract(11, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(10, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(9, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(8, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(7, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(6, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(5, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(4, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(3, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(2, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().subtract(1, "months").format("MMM YYYY"));
            this.lineChartLabels.push(moment().format("MMM YYYY"));
            this.lineChartData.push({
                label: this.translateService.instant("home.missingRequired"),
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            });
            this.lineChartData.push({
                label: this.translateService.instant("home.mandatoryInserted"),
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            });
            this.lineChartData.push({
                label: this.translateService.instant("home.generics"),
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            });
            this.lineChartColors.push({
                backgroundColor: "rgba(255, 255, 255, 0)",
                borderColor: "#EF5350",
            });
            this.lineChartColors.push({
                backgroundColor: "rgba(255, 255, 255, 0)",
                borderColor: "#EC407A",
            });
            this.lineChartColors.push({
                backgroundColor: "rgba(255, 255, 255, 0)",
                borderColor: "#AB47BC",
            });
            this.subscriptions.push(this.tankService
                .getList(0, 10, "createdAt", "desc", { email: "" })
                .subscribe(function (res) {
                if (res) {
                    _this.tanksCount = res.data.totalCount;
                }
            }, function (err) {
                console.warn(err);
            }));
            this.subscriptions.push(this.propertiesService
                .getList(0, 10, "createdAt", "desc", { name: "" })
                .subscribe(function (res) {
                if (res) {
                    _this.propertiesCount = res.data.totalCount;
                }
            }, function (err) {
                console.warn(err);
            }));
            this.subscriptions.push(this.caretakersService.getCaretakers().subscribe(function (res) {
                if (res) {
                    _this.caretakersCount =
                        res &&
                            res.data &&
                            res.data.dipendenti &&
                            res.data.dipendenti.length
                            ? res.data.dipendenti.length
                            : 0;
                    _this.caretakersCount +=
                        res &&
                            res.data &&
                            res.data.impresePulizia &&
                            res.data.impresePulizia.length
                            ? res.data.impresePulizia.length
                            : 0;
                }
            }, function (err) {
                console.warn(err);
            }));
            this.subscriptions.push(this.usersService
                .getList(0, 10, "createdAt", "desc", { role: "temporary" })
                .subscribe(function (res) {
                if (res) {
                    _this.temporariesCount = res.data.totalCount;
                }
            }, function (err) {
                console.warn(err);
            }));
        }
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    HomeComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    return HomeComponent;
}());
export { HomeComponent };
